import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getAccountConfigs() {
    return {
        custom: {
            [PALETTE_IDS.ACCOUNT]: {
                AccountMenuContent: {
                    showWithdrawable: false,
                },
            },
        },
        palette: {
            [PALETTE_IDS.ACCOUNT_POPOVER]: {
                ACCOUNT_BALANCE_LABEL_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_NORMAL,
                    fontSize: FONT.SIZE_MEDIUM,
                    textTransform: 'uppercase',
                },
            },
            [PALETTE_IDS.MY_ACCOUNT_PAGE]: {
                MY_ACCOUNT_PAGE_MENU_HEADER_TEXT: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.MY_ACCOUNT_DIALOG]: {
                MY_ACCOUNT_DIALOG_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                MY_ACCOUNT_DIALOG_TAB_BUTTON_SELECTED_BG: COLOR.BRAND.BACKGROUND1,
                MY_ACCOUNT_DIALOG_TAB_BUTTON_TEXT: `${COLOR.BRAND.BACKGROUND1}|${COLOR.BRAND.FOREGROUND1}`,
            },
        },
    };
}
